import React from 'react';
import warning from 'warning';

var checkIndexBounds = function checkIndexBounds(props) {
  var index = props.index,
      children = props.children;
  var childrenCount = React.Children.count(children);
  warning(index >= 0 && index <= childrenCount, "react-swipeable-view: the new index: ".concat(index, " is out of bounds: [0-").concat(childrenCount, "]."));
};

export default checkIndexBounds;